import { Chip, Avatar, Icon, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Dialog, DialogContent } from "@material-ui/core";
import { red } from "@material-ui/core/colors";
import { useEffect } from "react";
import { FC, useState } from "react";
import { DateUtil } from "src/framework/commons";
import { ActionMenu, ActionMenuProperties } from "src/framework/components/base";
import api, { IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { confirmationDialog, DataGridStore, notifierStore } from "src/framework/store";
import { JobsType } from "src/types";
import { JobsForm } from "../../form/JobsForm";

const DEFAULT_CURRENT_EDIT: JobsType = {
  id: 0,
  nome: "",
  expressao: "",
}

const JobsDataTable: FC = () => {
  const [dataGridStore] = useState(new DataGridStore(api));

  const [agendamentos, setAgendamentos] = useState([]);
  const [currentEdit, setCurrentEdit] = useState<JobsType | null>();

  const [open, setOpen] = useState<boolean>(false);

  const renderNome = (row: any) => {

    return (<>
      <Chip
        size="small"
        avatar={
          <Avatar
            style={{
              backgroundColor: row.status ? "#00a335" : red[500],
              color: "white",
            }}
          >
            <Icon fontSize="small">{row.status ? "check" : "clear"}</Icon>
          </Avatar>
        }
        label={row.nome}
      />
    </>)
  }

  const renderActionMenu = (row: any) => {
    const active: boolean = row.status === true;
    let menu: ActionMenuProperties = {
      selected: null,
      menuItens: [
        {
          label: "Editar",
          key: btoa("editar-" + Math.random()),
          icon: "edit",
          onClick: async () => {
            setCurrentEdit({
              id: row.id,
              nome: row.nome,
              expressao: row.expressao,
            });

            setOpen(true);
          },
        },
        {
          label: active ? "Desativar" : "Ativar",
          key: btoa("ativar-" + Math.random()),
          icon: !active ? "check_box_outline_blank" : "check_box_outline",
          onClick: async () => {
            confirmationDialog.setup({
              content: `${active ? "Desativar" : "Ativar"} job "${row.nome}" ?`,
              onConfirmation: async () => {

                let urlAgendamento = "";

                if (row.status)
                  urlAgendamento = `/agendamentos/parar/${row.id}`
                else
                  urlAgendamento = `/agendamentos/iniciar/${row.id}`

                const response: IDataResponse = await api.post({
                  url: urlAgendamento,
                });

                if (response.statusCode === STATUS_CODE.OK) {
                  notifierStore.setNotifier({
                    title: "Aviso",
                    content: `Job "${row.nome}" ${active ? "desativado" : "ativado"} com sucesso!`,
                    timeOut: 3500,
                    onClose: () => {
                      notifierStore.setOpen(false);
                      init();
                    }
                  })
                  notifierStore.setOpen(true);
                }
                dataGridStore.list();
                confirmationDialog.close()
              },
              onClose: () => {
                confirmationDialog.close()
              },
              title: "Aviso",
            });
            confirmationDialog.open()
          },
        },
      ],
    };

    return (
      <>
        <ActionMenu {...menu} />
      </>
    );
  };

  const init = async () => {
    const request: IDataRequest = {
      url: "/agendamentos/consultar/?page=1&limit=50",
    }

    const responses: IDataResponse = await api.get(request);
    if (responses.statusCode === STATUS_CODE.OK) {
      setAgendamentos(responses.data);
    }
  }

  const atualizarJob = async (job: JobsType) => {

  }

  useEffect(() => {
    setTimeout(() => {
      init();
    }, 500)
  }, []);

  return <>
    <div className="row">
      <div className="X12">

        <TableContainer>
          <Table>

            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>ID</TableCell>
                <TableCell>Nome</TableCell>
                <TableCell>Expressão</TableCell>
                <TableCell>Ultima Execução</TableCell>
                <TableCell>Intancias</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {agendamentos?.map((row: any, idx: number) => {
                return (
                  <TableRow key={`row-valor-${idx}`}>
                    <TableCell>
                      {renderActionMenu(row)}
                    </TableCell>
                    <TableCell>
                      {row.id}
                    </TableCell>
                    <TableCell>
                      {renderNome(row)}
                    </TableCell>
                    <TableCell>
                      {row.expressao}
                    </TableCell>
                    <TableCell>
                      {DateUtil.dateFormat(row.ultima_execucao, "DD-MM-YYYY HH:mm:ss")}
                    </TableCell>
                    <TableCell>
                      {row.instancias}
                    </TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

    </div>

    <Dialog open={open} className="JobsFrom" fullWidth={true}>
      <DialogContent>
        <JobsForm
          job={currentEdit || DEFAULT_CURRENT_EDIT}
          onConfirmar={(value: JobsType) => {

          }}
          onClose={() => {
            setOpen(false);
          }} />
      </DialogContent>

    </Dialog>
  </>
}

export { JobsDataTable }